import { HighlightsPanel } from "./HighlightsPanel";
import { useWSMgrContext } from "@/providers/WsMgrProvider";

/*
 * type Props = {
 *   manager: QHighlightMgr
 * }
 */
export const InteractiveHighlightGroup = props => {
  useWSMgrContext();
  const ApplySavedContent =
    ({ ApplyChartHighlights, ToggleSavedContent }) =>
    event => {
      ToggleSavedContent(event.target.id);
      ApplyChartHighlights();
    };

  const NormalizeLayerChildren = (children, GetSublayerContent) => {
    return children.map((item, index) => ({
      name: item[0],
      values: GetSublayerContent,
      active: item[1],
      color: item[2],
      index: index
    }));
  };

  const GetSavedContent = () => {
    return props.manager.GetAllowedHighlightList();
  };

  const GetNormalizedSavedList = () => {
    const savedData = props.manager.GetAllowedHighlightList();
    let savedList = savedData.map((item, index) => ({
      name: item.GetName(),
      id: index,
      enabled: item.GetFilterApplied(),
      color: item.GetHighlightColor(),
      hidden: item.fHidden
    }));

    return savedList.filter(item => !item.hidden);
  };

  return (
    <HighlightsPanel
      manager={props.manager}
      canShowInteractiveHighlights={props.canShowInteractiveHighlights}
      GetSavedContent={GetSavedContent}
      ApplySavedContent={ApplySavedContent}
      NormalizeLayerChildren={NormalizeLayerChildren}
      GetNormalizedSavedList={GetNormalizedSavedList}
    />
  );
};
